<template>
  <div>
    <top-title :name="titleName" style="margin: 20px 20px; min-width: 980px"></top-title>

    <div class="integralEden">
      <div class="content" v-if="createStep == 1">
        <!-- 头部导航切换 -->
        <!-- <div class="navTab" v-if="allHide == true">
          <span class="tab" :class="{ active: tabActive == 1 }" @click="tabActive = 1">创建活动</span>
          <span class="tab" :class="{ active: tabActive == 2 }" @click="tabActive = 2">活动管理</span>
        </div> -->
        <!-- 创建活动 -->
        <ul class="activity" v-show="tabActive == 1" v-loading="showLoading">
          <li class="item" v-for="item in activityForm" :key="item.id">
            <div class="wrap">
              <img :src="item.scr" class="img" />
              <div class="info">
                <span class="tit">{{ item.name }}</span>
                <span class="desc">{{ item.desc }}</span>
                <div class="btn">
                  <button class="btn-option" @click="createActivity(item)">立即创建</button>
                  <button class="btn-bg" @click="handleActiav(item)">管理活动</button>
                </div>
              </div>
            </div>
          </li>
        </ul>
        <!-- 活动管理 -->
        <activity-manage
          :titlName="titlName"
          v-if="tabActive == 2"
          @changeData="changeData"
          @changeStatus="changeStatus"
          @goback="goback"
          :actManag="3"
        ></activity-manage>
      </div>

      <!-- 游戏 -->
      <points-task-games
        @saveEdit="saveEditChange"
        v-if="createStep == 2"
        @returnBack="returnBackChange"
        :activityData="activityData"
      ></points-task-games>
    </div>
  </div>
</template>

<script>
import { prefixurl } from "@/api/paradiseAndTaskCommonController.js";
import topTitle from "../../components/top-title";
import pointsTaskGames from "./points_task_games.vue";
import activityManage from "./activityManage";
import { getSellerInfo } from "@/api/sellerController";

export default {
  components: {
    topTitle,
    pointsTaskGames,
    activityManage,
  },
  data() {
    return {
      titlName: "疯狂抓娃娃",
      titleName: "游戏中心",
      // 导航选中
      tabActive: 1,
      createStep: 1,
      activityData: null,
      activityForm: [],
      allHide: true,
      activityUrl: "",
      venderId: "",
      idUrl1: "",
      idUrl2: "",
      idUrl3: "",
      idUrl4: "",
      showLoading: true,
      createStepId: "",
    };
  },
  async created() {
    await this.prefixQue();
    await this.getSellerInfo();
  },
  methods: {
    //获取活动地址
    async prefixQue() {
      const res = await prefixurl();
      this.activityUrl = res.data.activityUrl;
      this.venderId = res.data.venderId;
      this.idUrl1 = this.activityUrl + "/" + "lottery_turntable" + "?venderId=" + this.venderId;
      this.idUrl2 = this.activityUrl + "/" + "clientPreview" + "?venderId=" + this.venderId + "&activityType=19";
      this.idUrl3 = this.activityUrl + "/" + "clientPreview" + "?venderId=" + this.venderId;
      this.idUrl4 = this.activityUrl + "/" + "clientPreview" + "?venderId=" + this.venderId;
      // .then((res) => {
      //   this.activityUrl = res.data.activityUrl;
      //   this.venderId = res.data.venderId;
      //   this.idUrl1 = this.activityUrl + "/" + "lottery_turntable" + "?venderId=" + this.venderId;
      //   this.idUrl2 = this.activityUrl + "/" + "clientPreview" + "?venderId=" + this.venderId + "&activityType=19";
      // })
    },
    createActivity(val) {
      console.log(val);
      this.createStep = 2;
      this.activityData = val;
      this.titleName = val.name;
    },
    handleActiav(val) {
      this.titlName = val.name;
      this.tabActive = 2;
      this.titleName = "活动管理";
    },
    returnBackChange() {
      this.createStep = 1;
      this.titleName = "游戏中心";
    },
    changeData() {
      this.allHide = false;
    },
    changeStatus() {
      this.allHide = true;
    },
    saveEditChange(val) {
      this.createStep = 1;
      this.tabActive = 2;
      this.titlName = val == 23 ? "疯狂抓娃娃" : "大家来找茬";
      this.titleName = "活动管理";
      // this.allHide = true;
      // console.log(this.allHide, "saveEditChange");
    },
    // 玩法权限
    getSellerInfo() {
      getSellerInfo().then((res) => {
        this.showLoading = false;
        res.data.permissions.forEach((item) => {
          if (item === "gamehub:catchDoll") {
            this.activityForm.push({
              id: 23,
              name: "疯狂抓娃娃",
              telCode: this.idUrl3,
              scr: require("../../assets/images/integralCenter/game-zww.png"),
              desc: "新奇趣味的在线抓娃娃游戏，玩游戏的同时赢取礼品，增加客户留存以及提升客户的粘性",
            });
          } else if (item === "gamehub:findDiffer") {
            this.activityForm.push({
              id: 24,
              name: "大家来找茬",
              telCode: this.idUrl4,
              scr: require("../../assets/images/integralCenter/game-zc.png"),
              desc: "“大家来找茬”是一款热门休闲的游戏，在限定时间内，找出两幅图的不同之处，通关后即可参与抽奖赢取礼品",
            });
          }
        });
      });
    },
    goback(val) {
      if (val == 1) {
        this.createStep = 1;
        this.tabActive = 1;
        this.titleName = "游戏中心";
      } else {
        let obj = {
          id: 23,
          name: "疯狂抓娃娃",
          telCode: this.idUrl3,
          scr: require("../../assets/images/integralCenter/game-zww.png"),
          desc: "新奇趣味的在线抓娃娃游戏，玩游戏的同时赢取礼品，增加客户留存以及提升客户的粘性",
        };
        if (this.titlName == "大家来找茬") {
          obj.id = 24;
          obj.telCode = this.idUrl4;
          obj.name = "大家来找茬";
          obj.desc = "“大家来找茬”是一款热门休闲的游戏，在限定时间内，找出两幅图的不同之处，通关后即可参与抽奖赢取礼品";
        }
        this.createActivity(obj);
      }
    },
  },
};
</script>

<style scoped lang="scss">
.integralEden {
  box-sizing: border-box;
  padding: 0 20px;
  min-width: 1080px;
  .content {
    min-height: 880px;
    margin: 20px 0 30px 0;
    background: rgba(255, 255, 255, 1);
    // box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
    border-radius: 6px;
    .navTab {
      display: flex;
      align-items: center;
      box-sizing: border-box;
      padding: 0 20px;
      position: relative;
      height: 50px;
      font-size: 14px;
      color: #666;
      border-bottom: 1px solid #f6f6f6;
      span {
        height: 50px;
        line-height: 50px;
        position: relative;
        padding: 0 11px;
        cursor: pointer;
        transition: all 0.2s;
      }
      .active {
        color: #2062e7;
        &::before {
          content: "";
          position: absolute;
          left: 50%;
          bottom: 0;
          transform: translateX(-50%);
          width: 80%;
          height: 2px;
          background-color: #2062e7;
          transition: all 0.2s;
          animation: opation 0.2s;
        }
        @keyframes opation {
          0% {
            opacity: 0;
          }
          100% {
            opacity: 100%;
          }
        }
      }
    }
    .activity {
      display: flex;
      flex-wrap: wrap;
      align-content: baseline;
      box-sizing: border-box;
      padding: 30px 14px;
      list-style: none;
      height: 500px;
      min-width: 1366px;
      .item {
        flex: 1;
        max-width: 33.33%;
        min-width: 480px;
        box-sizing: border-box;
        padding: 0 14px;
        margin-bottom: 20px;
        .wrap {
          display: flex;
          box-sizing: border-box;
          padding: 0 15px;
          height: 220px;
          box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
          border-radius: 6px;
          background-color: #fff;
          transition: all 0.2s;
          &:hover {
            box-shadow: 0px 0px 16px rgba(0, 0, 0, 0.2);
          }
          .img {
            flex-shrink: 0;
            height: 213px;
            margin-top: 5px;
          }
          .info {
            flex: 1;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            padding: 30px 0 16px 0;
            .tit {
              font-size: 16px;
              color: #333;
            }
            .desc {
              margin: 15px 0;
              font-size: 14px;
              line-height: 24px;
              color: #333;
            }
            .btn {
              text-align: right;
              button {
                width: 94px;
                height: 32px;
                // line-height: 28px;
                text-align: center;
                border-radius: 2px;
                border: 1px solid #2062e7;
                cursor: pointer;
                outline: none;
                transition: all 0.2s;
              }
              &-option {
                color: #fff;
                background-color: #2062e7;
              }
              &-bg {
                color: #2062e7;
                background-color: #fff;
                margin-left: 15px;
              }
              &-option:hover {
                opacity: 0.8;
              }
              &-bg:hover {
                background-color: #2062e7;
                color: #fff;
              }
            }
          }
        }
      }
    }
  }
}
</style>
